import { createApp } from "vue";
import App from "./App.vue";
import { createI18n } from "vue-i18n";
import ar from "./locales/ar.json";
import en from "./locales/en.json";
import "./assets/styles/main.css";

const messages = { ar, en };

const i18n = createI18n({
    locale: "ar",
    fallbackLocale: "en",
    messages,
});

createApp(App).use(i18n).mount("#app");
